import { useAppLaunch } from "@src/hooks/appLaunch";
import Loading from "@src/utils/Loading";

export const Launch = () => {
  useAppLaunch();

  return <Loading />;
};
